
enum PricingSubmissionType {
	MANUAL='MANUAL',
	AUTOMATIC='AUTOMATIC'
}

export default PricingSubmissionType;